import theme from '@ui/theme';
import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()(() => {
  return {
    carouselPhotoContainer: {
      width: '100%',
      height: '100%',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontFamily: theme.gh_vars.circular,
      textDecoration: 'none !important',
      marginTop: theme.spacing(3)
    },
    primaryPhoto: {
      height: '100%',
      width: '100%',
      objectFit: 'cover',
      maxHeight: 250,
      [theme.breakpoints.up('sm')]: {
        maxHeight: 600
      }
    },
    roomInfoContainer: {
      position: 'absolute',
      top: theme.spacing(3),
      left: theme.spacing(3),
      zIndex: 10,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        width: 'calc(100% - 36px)',
      }
    },
    roomTitle: {
      color: '#fff',
      fontSize: 18,
      fontFamily: theme.gh_vars.circular,
      marginRight: theme.spacing(1.5)
    },
  };
});
